(function () {
  const popup = document.getElementById('la-engraving-popup');
  if (!popup) return;

  if (popup.parentElement !== document.body) {
    document.body.appendChild(popup);
  }

  const closeSelectors = '[data-la-engraving-popup-close]';
  const easifyRootSelector = '.easify-product-options';
  const triggerSelector = '.la-engraving-popup-trigger, [data-la-open-engraving-popup]';
  const switchSelector = [
    '.easify-product-options input[type="checkbox"]',
    '.easify-product-options input[role="switch"]',
    '.easify-product-options [class*="switch"] input',
    '.easify-product-options [class*="Switch"] input',
  ].join(',');

  function slots() {
    return popup.querySelectorAll('.la-engraving-popup__slot');
  }

  function unloadSlot(slot) {
    const video = slot.querySelector('video');
    if (!video) return;
    video.pause();
    video.removeAttribute('src');
    video.load();
    slot.classList.remove('is-playing');
  }

  function unloadAll() {
    slots().forEach(unloadSlot);
  }

  function loadAndPlay(slot) {
    const video = slot.querySelector('video');
    const src = slot.getAttribute('data-video-src');
    if (!video || !src) return;

    slots().forEach(function (other) {
      if (other !== slot) {
        const otherVideo = other.querySelector('video');
        if (otherVideo) otherVideo.pause();
      }
    });

    if (video.getAttribute('src') !== src) {
      video.src = src;
    }
    slot.classList.add('is-playing');
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function openPopup() {
    if (typeof popup.showModal === 'function') {
      if (!popup.open) popup.showModal();
    } else {
      popup.setAttribute('open', '');
    }
  }

  function closePopup() {
    unloadAll();
    if (typeof popup.close === 'function' && popup.open) {
      popup.close();
    } else {
      popup.removeAttribute('open');
    }
  }

  window.LAEngravingPopup = {
    open: openPopup,
    close: closePopup,
  };

  document.addEventListener(
    'click',
    function (event) {
      const trigger = event.target.closest(triggerSelector);
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        openPopup();
        return;
      }

      if (event.target.closest(closeSelectors)) {
        event.preventDefault();
        closePopup();
      }
    },
    true
  );

  popup.addEventListener('click', function (event) {
    if (event.target === popup) closePopup();
  });

  popup.addEventListener('cancel', function () {
    unloadAll();
  });

  popup.addEventListener('click', function (event) {
    const poster = event.target.closest('.la-engraving-popup__poster');
    if (!poster || !popup.contains(poster)) return;
    event.preventDefault();
    loadAndPlay(poster.closest('.la-engraving-popup__slot'));
  });

  popup.addEventListener(
    'play',
    function (event) {
      if (!event.target.matches('.la-engraving-popup__video')) return;
      slots().forEach(function (slot) {
        const video = slot.querySelector('video');
        if (video && video !== event.target) video.pause();
      });
    },
    true
  );

  function switchesOn() {
    const inputs = document.querySelectorAll(switchSelector);
    if (!inputs.length) return null;
    return Array.prototype.some.call(inputs, function (input) {
      return input.checked;
    });
  }

  function syncTriggerVisibility() {
    const roots = document.querySelectorAll(easifyRootSelector);
    const personalised = switchesOn();

    roots.forEach(function (root) {
      if (personalised === true) root.classList.add('is-la-personalise-on');
      else root.classList.remove('is-la-personalise-on');
    });

    document.querySelectorAll(triggerSelector).forEach(function (button) {
      if (personalised === null) {
        button.classList.add('is-la-visible');
      } else if (personalised) {
        button.classList.add('is-la-visible');
      } else {
        button.classList.remove('is-la-visible');
      }
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest(easifyRootSelector)) syncTriggerVisibility();
  });

  function watchEasify() {
    const root = document.querySelector(easifyRootSelector);
    if (!root) return;
    const observer = new MutationObserver(function (mutations) {
      const onlyOurClass = mutations.every(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'class';
      });
      if (onlyOurClass) return;
      observer.disconnect();
      syncTriggerVisibility();
      observer.observe(root, { childList: true, subtree: false });
    });
    observer.observe(root, { childList: true, subtree: false });
    syncTriggerVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchEasify);
  } else {
    watchEasify();
  }

  document.addEventListener('tpo_loaded', syncTriggerVisibility);
})();
